import { useEffect } from 'react';

const useScript = (resourceUrl, typeScript) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = resourceUrl;
    script.async = true;
    if(typeScript){
      script.type = typeScript;
    }
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [resourceUrl]);
};

export default useScript;
